import { IInitialState } from '../../../reduxService';
import { EConversionImperialToSI, convertTo } from '../../conversion';
import { EProjectType, UnitOfMeasure } from '../../enum/project';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { IChannelGeometrySteppedWeirForm, IChannelGeometryVerticalDropForm } from '../components/InputForm/ChannelGeometry/IChannelGeometry';
import { IHydraulicDataSlopedWeirForm, IHydraulicDataSteppedWeirForm, IHydraulicDataVerticalDropForm } from '../components/InputForm/HydraulicData/IHydraulicData';
import { ISoilDataVerticalDropForm } from '../components/InputForm/SoilData/ISoilData';
import { IStillingBasinSteppedWeirSlopedWeirForm, IStillingBasinVerticalDropForm } from '../components/InputForm/StillingBasin/IStillingBasin';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm, IWingsGeometrySteppedWeirForm, IWingsGeometryVerticalDropForm } from '../components/InputForm/WingsGeometry/IWingsGeometry';

export const conversionMacra2 = (store: any) => (next: any) => (action: any) => {
    let projectInfo: IInitialState<IProjectInfoForm> = store.getState().projectInfo;
    let isImperial = projectInfo.data?.unitOfMeasure == UnitOfMeasure.Imperial;
    let isSlopedWeir = projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.SlopedWeir);
    let isStepped = projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.SteppedWeir);
    let isVertical = projectInfo.data?.type === (EProjectType.Macra2 | EProjectType.VerticalDrop);
    if (action.type === 'projectMacra2/setHydraulicData' && isImperial) {
        let hydraulicData;
        if (isStepped) {
            hydraulicData = action.payload as IHydraulicDataSteppedWeirForm;
        } else {
            hydraulicData = action.payload as IHydraulicDataVerticalDropForm | IHydraulicDataSlopedWeirForm;
        }
        hydraulicData = {
            ...hydraulicData,
            soilAdmissibleVelocity: convertTo((<IHydraulicDataSlopedWeirForm>hydraulicData).soilAdmissibleVelocity, EConversionImperialToSI.fts_to_ms),
            discharge: convertTo(hydraulicData.discharge, EConversionImperialToSI.ft3s_to_m3s),
        };
        action.payload = hydraulicData;
    }
    if (action.type === 'projectMacra2/setGeometry' && isImperial) {
        let geometryForm: IChannelGeometryVerticalDropForm | IChannelGeometrySteppedWeirForm = action.payload;
        geometryForm = {
            ...geometryForm,
            bankTopElevation: convertTo(geometryForm.bankTopElevation, EConversionImperialToSI.ft_to_m),
            channelWidth: convertTo(geometryForm.channelWidth, EConversionImperialToSI.ft_to_m),
        };
        action.payload = geometryForm;
    }
    if (action.type === 'projectMacra2/setWeirGeometry' && isImperial) {
        if (isVertical) {
            let weirGeometryForm: IWeirGeometryVerticalDropForm;
            weirGeometryForm = action.payload as IWeirGeometryVerticalDropForm;
            weirGeometryForm = {
                ...weirGeometryForm,
                foundation: convertTo(weirGeometryForm.foundation, EConversionImperialToSI.ft_to_m),
                layer:
                    !!weirGeometryForm.layer && !!weirGeometryForm.layer.length && weirGeometryForm.layer.length > 0
                        ? weirGeometryForm.layer.map(wg => ({
                              ...wg,
                              layerWidth: convertTo(wg.layerWidth, EConversionImperialToSI.ft_to_m),
                              layerOffset: convertTo(wg.layerOffset, EConversionImperialToSI.ft_to_m),
                              layerHeight: convertTo(wg.layerHeight, EConversionImperialToSI.ft_to_m),
                          }))
                        : [],
            };
            action.payload = weirGeometryForm;
        }
        if (isSlopedWeir) {
            let weirGeometryForm: IWeirGeometrySlopedWeirForm;
            weirGeometryForm = action.payload as IWeirGeometrySlopedWeirForm;
            weirGeometryForm = {
                ...weirGeometryForm,
                crestLength: weirGeometryForm.crestLength! >= 0 ? convertTo(weirGeometryForm.crestLength!, EConversionImperialToSI.ft_to_m) : undefined,
                liningThickness: weirGeometryForm.liningThickness! >= 0 ? convertTo(weirGeometryForm.liningThickness!, EConversionImperialToSI.ft_to_m) : undefined,
                height: weirGeometryForm.height! >= 0 ? convertTo(weirGeometryForm.height!, EConversionImperialToSI.ft_to_m) : undefined,
            };
            action.payload = weirGeometryForm;
        }
        if (isStepped) {
            let weirGeometryForm: IWeirGeometrySteppedWeirForm;
            weirGeometryForm = action.payload as IWeirGeometrySteppedWeirForm;
            let stepHeight: number = weirGeometryForm.stepHeight! >= 0 ? convertTo(weirGeometryForm.stepHeight, EConversionImperialToSI.ft_to_m) : 0;
            weirGeometryForm = {
                ...weirGeometryForm,
                gabionWidth: weirGeometryForm.gabionWidth! >= 0 ? convertTo(weirGeometryForm.gabionWidth!, EConversionImperialToSI.ft_to_m) : undefined,
                stepHeight,
            };
            action.payload = weirGeometryForm;
        }
    }
    if (action.type === 'projectMacra2/setWingsGeometry' && isImperial) {
        let wingsGeometryForm: IWingsGeometrySteppedWeirForm | IWingsGeometrySlopedWeirForm | IWingsGeometryVerticalDropForm;
        wingsGeometryForm = action.payload;
        wingsGeometryForm = {
            ...wingsGeometryForm,
            width: wingsGeometryForm.width! >= 0 ? convertTo(wingsGeometryForm.width!, EConversionImperialToSI.ft_to_m): undefined,
            offset: wingsGeometryForm.offset! >= 0 ? convertTo(wingsGeometryForm.offset!, EConversionImperialToSI.ft_to_m) : undefined,
            height: wingsGeometryForm.height! >= 0 ? convertTo(wingsGeometryForm.height!, EConversionImperialToSI.ft_to_m) : undefined,
        };
        action.payload = wingsGeometryForm;
    }
    
    if (action.type === 'projectMacra2/setSoilData' && isImperial) {
        let soilForm: ISoilDataVerticalDropForm = action.payload;
        soilForm = {
            ...soilForm,
            rockFillUnitWeight: soilForm.rockFillUnitWeight! >= 0 ? convertTo(soilForm.rockFillUnitWeight!, EConversionImperialToSI.lbfft3_to_kNm3) : undefined,
            granularMaterialDownstream: soilForm.granularMaterialDownstream! >= 0 ? convertTo(soilForm.granularMaterialDownstream!, EConversionImperialToSI.in_to_mm) : undefined,
            material: {
                ...soilForm.material!,
                physicalData: soilForm.material?.physicalData?.map(pd => ({
                    ...pd,
                    soilUnitWeight: convertTo(pd.soilUnitWeight ?? 0, EConversionImperialToSI.lbfft3_to_kNm3),
                })),
            },
        };
        action.payload = soilForm;
    }
    if (action.type === 'projectMacra2/setStillingBasin' && isImperial) {
        let stillingBasinForm: IStillingBasinSteppedWeirSlopedWeirForm | IStillingBasinVerticalDropForm = action.payload;
        stillingBasinForm = {
            ...stillingBasinForm,
            counterweirElevation: stillingBasinForm.counterweirElevation! >= 0 ? convertTo(stillingBasinForm.counterweirElevation!, EConversionImperialToSI.ft_to_m) : undefined,
            poolLength: stillingBasinForm.poolLength! >= 0 ? convertTo(stillingBasinForm.poolLength!, EConversionImperialToSI.ft_to_m) : undefined,
            width: stillingBasinForm.width! >= 0 ? convertTo(stillingBasinForm.width!, EConversionImperialToSI.ft_to_m) : undefined,
            stillingBasinElevation:
                stillingBasinForm.stillingBasinElevation || stillingBasinForm.stillingBasinElevation == 0
                    ? convertTo(stillingBasinForm.stillingBasinElevation, EConversionImperialToSI.ft_to_m)
                    : undefined,
            thickness: stillingBasinForm.thickness! >= 0 ? convertTo(stillingBasinForm.thickness!, EConversionImperialToSI.ft_to_m) : undefined,
        };
        action.payload = stillingBasinForm;
    }

    return next(action);
};
